import { render, staticRenderFns } from "./CoSwitch.vue?vue&type=template&id=69e7d92a&"
import script from "./CoSwitch.vue?vue&type=script&lang=ts&"
export * from "./CoSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./CoSwitch.vue?vue&type=style&index=0&id=69e7d92a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports